import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { FiPhoneCall } from "react-icons/fi";
import { IoLogoWhatsapp } from "react-icons/io";
import { MdEmail } from "react-icons/md";
import React from "react";

function SocialMedia() {
  return (
    <ul className="home-about-social-links">
      <li className="social-icons">
        <a
          href="https://github.com/Jubershaikh2307"
          target="_blank"
          rel="noreferrer"
          className="icon-colour  home-social-icons"
        >
          <AiFillGithub className="social-icon" />
        </a>
      </li>
      <li className="social-icons">
        <a
          href="https://www.linkedin.com/in/juber-shaikh-25482a176/"
          target="_blank"
          rel="noreferrer"
          className="icon-colour  home-social-icons"
        >
          <FaLinkedinIn className="social-icon" />
        </a>
      </li>
      <li className="social-icons">
        <a
          href="mailto:jubershaikh2307@gmail.com"
          target="_blank"
          rel="noreferrer"
          className="icon-colour home-social-icons"
        >
          <MdEmail className="social-icon" />
        </a>
      </li>
      <li className="social-icons">
        <a
          href="tel:+918055154446"
          rel="noreferrer"
          className="icon-colour home-social-icons"
        >
          <FiPhoneCall className="social-icon" />
        </a>
      </li>
      <li className="social-icons">
        <a
          href="https://api.whatsapp.com/send?phone=918055154446&text=Hello"
          target="_blank"
          rel="noreferrer"
          className="icon-colour home-social-icons"
        >
          <IoLogoWhatsapp className="social-icon" />
        </a>
      </li>
    </ul>
  );
}
export default SocialMedia;
